import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { auth_actions } from "../../../../redux-store";
import useFormState from "../../../../utils/useFormState";

const ChangePassword = () => {
  const { handleSubmit, register, errors, getValues, reset } = useForm();
  const { formValues, handleChange, isButtonDisabled } = useFormState({
    curr_pass: "",
    new_pass: "",
    conf_password: "",
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const dispatch = useDispatch();

  const changePasswordHandler = async () => {
    const data = getValues();
    setIsSubmitting(true);

    try {
      await dispatch(auth_actions.update_password(data));
      reset();
    } catch (error) {
      console.error("Error updating password: ", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="dashboard">
      <div className="box-account box-info">
        <div className="box-head">
          <h2>Change Password</h2>
        </div>
        <div className="row mt-3">
          <div className="col-lg-12 mx-auto register-page section-b-space">
            <div className="theme-card">
              <form
                className="theme-form"
                onSubmit={handleSubmit(changePasswordHandler)}
              >
                <div className="col md-6">
                  <div className="form-group">
                    <label htmlFor="curr_pass">Current Password</label>
                    <input
                      type="password"
                      className="form-control mb-0"
                      id="curr_pass"
                      name="curr_pass"
                      placeholder="Current Password"
                      value={formValues.curr_pass}
                      onChange={handleChange}
                      ref={register({
                        required: {
                          value: true,
                          message: "This Field is Required",
                        },
                      })}
                    />
                    <label htmlFor="curr_pass" className="error">
                      {errors.curr_pass && errors.curr_pass.message}
                    </label>
                  </div>
                  <div className="form-group">
                    <label htmlFor="new_pass">New Password</label>
                    <input
                      type="password"
                      className="form-control mb-0"
                      id="new_pass"
                      name="new_pass"
                      placeholder="New Password"
                      value={formValues.new_pass}
                      onChange={handleChange}
                      ref={register({
                        required: {
                          value: true,
                          message: "This Field is Required",
                        },
                      })}
                    />
                    <label htmlFor="new_pass" className="error">
                      {errors.new_pass && errors.new_pass.message}
                    </label>
                  </div>
                  <div className="form-group">
                    <label htmlFor="conf_password">Confirm Password</label>
                    <input
                      type="password"
                      className="form-control mb-0"
                      id="conf_password"
                      name="conf_password"
                      placeholder="Confirm Password"
                      value={formValues.conf_password}
                      onChange={handleChange}
                      ref={register({
                        required: {
                          value: true,
                          message: "This Field is Required",
                        },
                        validate: (v) =>
                          getValues().new_pass === v || "Passwords don't match",
                      })}
                    />
                    <label htmlFor="conf_password" className="error">
                      {errors.conf_password && errors.conf_password.message}
                    </label>
                  </div>
                </div>
                <button
                  type="submit"
                  className="btn btn-solid"
                  disabled={isSubmitting || isButtonDisabled}
                >
                  {isSubmitting ? "Changing..." : "Change"}
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChangePassword;
